import { render, staticRenderFns } from "./cDocumentDashboardPieChart.vue?vue&type=template&id=483f7757&scoped=true"
import script from "./cDocumentDashboardPieChart.vue?vue&type=script&lang=js"
export * from "./cDocumentDashboardPieChart.vue?vue&type=script&lang=js"
import style0 from "./cDocumentDashboardPieChart.vue?vue&type=style&index=0&id=483f7757&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f7757",
  null
  
)

export default component.exports